import React, {useEffect, useRef, useState} from "react";
import {isInFav, addToFav, removeFromFav} from "../../components/favourites";

const FavButton = ({id, isButton}) => {

    const [inFav, setInFav] = useState(false);
    const [right, setRight] = useState(false);
    const container = useRef();
    const ref = useRef();


    useEffect(() => {
        if (isInFav(id)) {
            setInFav(true);
        }
    }, []);

    const add = () => {
        setInFav(true);
        addToFav(id);
    }

    const remove = () => {
        setInFav(false);
        removeFromFav(id);
    }

    const positionPopup = () => {

        if (container.current && ref.current) {
            const rect = container.current.getBoundingClientRect();
            const rightDistance = window.innerWidth - rect.x;
            if (rightDistance <= 200) {
                setRight(true);
            } else {
                setRight(false);
            }
        }

    }


    if (inFav) {
        if (isButton) {
            return <a href="#" className="btn btn--solid btn--solid--fawn" onClick={(e) => {
                e.preventDefault();
                remove();
            }}>
            Favourited
            </a>

        }
        return <a href="#" className="listing-card__fav" ref={container} onClick={(e) => {
            e.preventDefault();
            remove();
        }}>
            <img src="_resources/themes/horowhenua/dist/img/icons/star-solid-fill.svg" alt="" />
        </a>;

    }
    if (isButton){
        return <a href="#" ref={container} className="fav-button btn btn--solid btn--solid--fawn" onClick={(e) => {
            e.preventDefault();
            add();
        }} onMouseEnter={(e) => {
            positionPopup();
        }}>
            <div className={`listing-card__fav-popup ${right ? 'listing-card__fav-popup--right' : ''}`} ref={ref}>
                <p>
                    Saves this listing to your favourites. Access your favourites at the top of the page.
                </p>
            </div>
            Favourite
        </a>

    }
    return <a href="#" className="listing-card__fav" ref={container} onClick={(e) => {
        e.preventDefault();
        add();
    }} onMouseEnter={(e) => {
        positionPopup();
    }}>
        <div className={`listing-card__fav-popup ${right ? 'listing-card__fav-popup--right' : ''}`} ref={ref}>
            <p>
                Saves this listing to your favourites. Access your favourites at the top of the page.
            </p>
        </div>
        <img src="_resources/themes/horowhenua/dist/img/icons/star-solid-black.svg" alt="" />
    </a>

}
export default FavButton;
